import { Font } from 'types'

export function fontFamily(font: Font): string {
    switch (font) {
        case 'giphy':
            return `"nexablack"`
        case 'meme':
            return `"meme"`
        case 'fancy':
            return `"Brush Script MT", cursive`
        case 'pixel':
            return `"emulogic"`
        case 'subtitle':
            return 'interface'
    }
}

export function fontScale(font: Font): number {
    switch (font) {
        case 'meme':
            return 1.2
        case 'fancy':
            return 1.4
        case 'pixel':
            return 0.7
        default:
            return 1
    }
}

export function fontTitle(font: Font): string {
    switch (font) {
        case 'giphy':
            return 'GIPHY'
        case 'meme':
            return 'MEME'
        case 'fancy':
            return 'Fancy'
        case 'pixel':
            return 'Pixel'
        case 'subtitle':
            return 'Subtitle'
    }
}

export function fontUrl(font: Font): string {
    switch (font) {
        case 'giphy':
            return '/static/webfont/nexa_black-webfont.woff'
        case 'meme':
            return '/static/webfont/meme.woff'
        case 'pixel':
            return '/static/webfont/emulogic.woff'
        case 'subtitle':
            return '/static/webfont/InterFace_W_Bd.woff'
        default:
            return ''
    }
}
